import styled from 'styled-components';
const FlexContainer = styled.div `
  display: flex;
  justify-content: ${props => props.justifyContent || 'center'};
  flex-direction: ${props => props.direction || 'row'};
  flex-wrap: ${props => props.wrap || 'no-wrap'};
  gap: ${props => props.gap || 'unset'};
  align-items: ${props => props.alignItems || 'start'};
`;
export default FlexContainer;
